import { render, staticRenderFns } from "./gj-tree-manager.vue?vue&type=template&id=07476ed4&scoped=true&"
import script from "./gj-tree-manager.vue?vue&type=script&lang=js&"
export * from "./gj-tree-manager.vue?vue&type=script&lang=js&"
import style0 from "./gj-tree-manager.vue?vue&type=style&index=0&id=07476ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07476ed4",
  null
  
)

export default component.exports